<template>
    <component :is="componentName" :platId="platId" ref="componentRef"  >
        <el-form label-width="120px">
            <FormGroup>操作</FormGroup>
            <el-form-item  label="触发操作" required>
                <el-radio-group :disabled='global.isView' v-model="trigger_operation" @change="handleChange">
                    <el-radio :disabled='platId !=7' label="1">
                      操作并通知
                       <el-tooltip  effect="dark"  placement="top">
                          <div slot="content">
                            <p>以下场景在到达当天最多操作次数时，若托管再次触发会重新计数并操作：</p>
                            <p>1、第二日。</p>
                            <p>2、修改托管内容(除了名称外的任何修改)。</p>
                            <p>3、关闭开关，重新打开。</p>
                          </div>
                          <i class="el-icon-question pointer" style="color:rgb(96, 98, 102)"/>
                      </el-tooltip>
                    </el-radio>
                    <el-radio label="2">仅通知</el-radio>
                </el-radio-group>
                <el-alert
                    :closable="false"
                    type="warning">
                    <p>
                        <svg-icon icon-class="warn" class="font20px text-color-tips"></svg-icon>
                        筛选客户/集团/产品，与账户的关系
                    </p>
                    <template name='title'>若筛选的为【客户】【集团】【产品】，目标维度或操作层级为【账户】【计划/广告组/广告】，运行时，按照当时聚投已有的对应关系进行监控或操作，可在上方筛选区域，每个筛选项的后方点击【详情】查看账户是否缺失。当账户未归属客户，或产品投放了新账户聚投还未获取到时，监控或操作可能存在缺失，请注意！</template>
                </el-alert>
            </el-form-item>
        </el-form>
    </component>
</template>

<script>
import NotificationOnly from './notificationOnly.vue'
import ActionForm from './actionForm.vue'
import FormGroup from '../../formGroup.vue';
export default {
    name: 'ActionInfo',
    props: [ 'platId' ],
    inject: [ 'global' ],
    components: {
        NotificationOnly,
        ActionForm,
        FormGroup
    },
    data() {
        return {
            componentName: 'ActionForm',
            trigger_operation: '1',
        }
    },
    methods: {
      handleChange(val, isConfirm = true) {
        if (isConfirm) {
          this.$confirm('修改后当前编辑的内容不会被保存，确定要修改吗？?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.trigger_operation = val;
            this.componentName = val === '1' ? 'ActionForm' : 'NotificationOnly';
          }).catch(() => {
            this.trigger_operation = val === '1' ? '2' : '1';
          })
        } else {
          this.trigger_operation = val;
          this.componentName = val === '1' ? 'ActionForm' : 'NotificationOnly';
        }
      },
      setFormData(data) {
        const trigger_operation = data.trigger_operation || '2';
        this.trigger_operation = trigger_operation;
        this.handleChange(trigger_operation, false);
        this.$nextTick(()=> {
          this.$refs.componentRef.setFormData(data);
        })
      },
      async validateFn() {
        const data = await this.$refs.componentRef.validateFn()
        return {
          trigger_operation: this.trigger_operation,
          ...data
        };
      }
    },
    watch: {
        platId(val) {
            if (val == 7) {
              this.componentName = 'ActionForm';
              this.trigger_operation = '1'
            }else {
              this.componentName = 'NotificationOnly';
              this.trigger_operation = '2'
            }
            
        }
    }
}
</script>

<style lang="scss" scoped>

</style>